import React, {
    useState,
    useEffect,
    useRef
} from "react";
import {
    Row,
    Col,
    Button,
    Modal,
    Table,
    Navbar,
    Nav,
    OverlayTrigger,
    Tooltip,
    Popover,
} from "react-bootstrap";
import { getFromLS, setToLS } from "../../utils/storage";
import * as Icon from "react-bootstrap-icons";
import { logout } from "../../utils";
import { toast } from "react-toastify";
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import "./kone.css"
import { ThreeCircles, Bars } from "react-loader-spinner";
import { BlankPage } from "./CompareK1Page/BlankPage";
import { FieldPage } from "./CompareK1Page/FieldPage";
import { ReturnModal } from "./ReturnModal";
// Core viewer
import { Viewer } from '@react-pdf-viewer/core';
import Draggable from 'react-draggable';
import { Rnd } from 'react-rnd';
// import mapage1 from './UIMetadata/massachusettspage1.json'
// import mapage2 from './UIMetadata/massachusettspage2.json'
// import mapage3 from './UIMetadata/massachusettspage3.json'
// import mapage4 from './UIMetadata/massachusettspage4.json'

// // Import styles
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { rotatePlugin } from '@react-pdf-viewer/rotate';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css'; import { v4 } from "uuid";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

export const SummaryComparisonFullWindowModal = ({ onHide, ...props }) => {
    // console.log("COMPARISON FULL MODAL: ", props)
    const rotatePluginInstance = rotatePlugin();
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const { RotatePage } = rotatePluginInstance;
    const token = getFromLS("token")
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
    };
    const [activePage, setActivePage] = useState(1)
    const [rowData, setRowData] = useState([
        {
            "Page 1": [
                {
                    "SCHEDULE E, PAGE 2": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": true },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Ordinary business income (loss)": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Rental real estate income (loss)": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Other net rental income (loss)": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Intangible drilling costs/dry hole costs": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Self-charged passive interest expense": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Guaranteed payments": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Section 179 and carryover": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Disallowed section 179 expense": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Excess farm loss": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Net income (loss)": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "First passive other": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Second passive other": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Cost depletion": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Percentage depletion": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Depletion carryover": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Disallowed due to 65% limitation": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Unreimbursed expenses (nonpassive)": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Nonpassive other": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Total Schedule E (page 2)": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "FORM 4797": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": true },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Section 1231 gain (loss)": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Section 179 recapture on disposition": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "SCHEDULE D": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": true },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Net short-term cap. gain (loss)": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Net long-term cap. gain (loss)": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Section 1256 contracts & straddles": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "FORM 4952": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": true },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Investment interest expense - Sch. A": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Other net investment income": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "ITEMIZED DEDUCTIONS": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": true },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Charitable contributions": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Deductions related to portfolio income": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Other": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },


            ]
        }, {
            "Page 2": [
                {
                    "INTEREST AND DIVIDENDS": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": true },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Interest income": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Interest from U.S. bonds": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Ordinary dividends": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Qualified dividends": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Tax-exempt interest income": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "FORM 6251": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": true },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Depreciation adjustment afetr 12/31/86": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Adjusted gain or loss": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Beneficiary's AMT adjustment": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Depletion (other than oil)": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Other": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "MISCELLANEOUS": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": true },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Self-employment earnings (loss)/Wages": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Gross farming & fishing inc": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Royalties": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Royalty expenses/depletion": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Undistributed capital gains credit": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Backup witholding": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Credit for estimated tax": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Cancellation of debt": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Medical insurance - 1040": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Dependent care benefits": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Retirement plans": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Passthrough adjustment to Form 1040": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Penalty on early withdrawal of savings": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "NOL": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Other taxes/recapture of credits": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Credits": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Casualty and theft loss": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "FORM 8995": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": true },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": true },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": true },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": true },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": true },
                        "Prior Year Passive Loss": { "value": "", "disabled": true },
                        "Disallowed Passive Loss": { "value": "", "disabled": true },
                        "Tax Return": { "value": "", "disabled": true }
                    }
                },
                {
                    "Qualified business income": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Qualified service income": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Section 199A W-2 wages": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                },
                {
                    "Section 199A unadjusted basis": {
                        "Other Passive": { "value": "", "disabled": true },
                        "K-1 Input": { "value": "", "disabled": false },
                        "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                        "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                        "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                        "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                        "Prior Year Passive Loss": { "value": "", "disabled": false },
                        "Disallowed Passive Loss": { "value": "", "disabled": false },
                        "Tax Return": { "value": "", "disabled": false }
                    }
                }]
        }])
    const [totalSummaryPages, setTotalSummaryPages] = useState(rowData.length)
    const [summaryComparisonData, setSummaryComparisonData] = useState([])
    const [activeKone, setActiveKone] = useState(
        {
            "K1FileId": undefined,
            "FirmId": "",
            "FileName": {
                "type": "button",
                "placeholder": "",
                "url": ""
            },
            "Status": "",
            "OriginalFileName": "",
            "OCRProgress": "",
            "PartnerName": "",
            "FormYear": "",
            "NumberOfPages": ''
        }
    )
    const [activeK1PdfUrl, setActiveK1PdfUrl] = useState(`./SAMPLE.pdf`)


    useEffect(() => {
        console.log("COMPARISON DATA: ", props.summarycomparisondata)
        setSummaryComparisonData(props.summarycomparisondata)
    }, [props.summarycomparisondata])

    useEffect(() => {
        if (summaryComparisonData.activekone !== undefined) {
            setActiveKone(summaryComparisonData.activekone)
        }
    }, [summaryComparisonData])

    const resetState = () => {
        setActiveKone({
            "K1FileId": undefined,
            "FirmId": "",
            "FileName": {
                "type": "button",
                "placeholder": "",
                "url": ""
            },
            "Status": "",
            "OriginalFileName": "",
            "OCRProgress": "",
            "PartnerName": "",
            "FormYear": "",
            "NumberOfPages": ''
        })
    }

    useEffect(() => {
        console.log("ACTIVE KONE: ", activeKone)
        if (activeKone !== undefined && activeKone.K1FileId !== undefined) {
            setActiveK1PdfUrl(`${process.env.REACT_APP_BASE_URI}/workflow/k1/download/${activeKone["FileName"]["url"].split("/")[activeKone["FileName"]["url"].split("/").length - 2]}/`)
        }
    }, [activeKone])

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            // if the pressed key is Enter, do something with the value
            setActivePage(e.target.value)
        }
    };

    const legendData = [
        { color: 'lightgreen', label: 'Valid field' },
        { color: 'lightpink', label: 'Invalid field' },
        { color: 'lightblue', label: 'Field has a footnote' }
    ];

    const headers = ["SCHEDULE E, PAGE 2", "FORM 4797", "SCHEDULE D", "FORM 4952", "ITEMIZED DEDUCTIONS", "INTEREST AND DIVIDENDS", "FORM 6251", "MISCELLANEOUS", "FORM 8995"]
    // useEffect(() => {
    //     console.log("ROW DATA: ", rowData)
    //     rowData.map((row, index) =>
    //         console.log(`${Object.keys(row)[0]}: `, Object.values(row)[0]["K-1 Input"])
    //     )
    // }, [rowData])

    const SummaryPageTableRenderer = (props) => {
        console.log("SUMMARY PAGE TABLE PROPS: ", props)
        const all_columns = Object.keys(Object.values(props.data[0])[0])
        const s = {
            "Section 199A unadjusted basis": {
                "Other Passive": { "value": "", "disabled": true },
                "K-1 Input": { "value": "", "disabled": false },
                "Prior Year Unallowed Basis Loss": { "value": "", "disabled": false },
                "Disallowed Due to Basis Limitation": { "value": "", "disabled": false },
                "Prior Year Unallowed At-Risk Loss": { "value": "", "disabled": false },
                "Disallowed Due to At-Risk": { "value": "", "disabled": false },
                "Prior Year Passive Loss": { "value": "", "disabled": false },
                "Disallowed Passive Loss": { "value": "", "disabled": false },
                "Tax Return": { "value": "", "disabled": false }
            }
        }
        return (
            <>
                <Row className="no-gutter">
                    <h6 style={{ textAlign: "center" }}>INCOME FROM PASSTHROUGH STATEMENT, {props.page.toUpperCase()}</h6>
                    <b>SCHEDULE E</b>
                    <Col md={1}><b>Name</b></Col>
                    <Col md={5}>
                        <input type="text"
                            className={
                                "summary-grid-kone-text-field"
                            }
                            value={""}
                            onChange={(event) =>
                                // updateField(props.rowIndex, event)
                                //  setValue(event.target.value)
                                console.log()
                            }
                            autoComplete="new-password"
                        />
                    </Col>
                    <Col md={4}></Col>
                    <Col md={1}><b>SSN/EIN</b></Col>
                    <Col md={1}>
                        <input type="text"
                            className={
                                "summary-grid-kone-text-field"
                            }
                            value={""}
                            onChange={(event) =>
                                // updateField(props.rowIndex, event)
                                //  setValue(event.target.value)
                                console.log()
                            }
                            autoComplete="new-password"
                        />
                    </Col>
                </Row>
                <Row className="no-gutter" style={{ marginTop: 10, marginBottom: 10 }}>
                    <Col md={1}><b>Passthrough</b></Col>
                    <Col md={5}>
                        <input type="text"
                            className={
                                "summary-grid-kone-text-field"
                            }
                            value={""}
                            onChange={(event) =>
                                // updateField(props.rowIndex, event)
                                //  setValue(event.target.value)
                                console.log()
                            }
                            autoComplete="new-password"
                        />
                    </Col>
                    <Col md={1}><b>ID</b></Col>
                    <Col md={1}><input type="text"
                        className={
                            "summary-grid-kone-text-field"
                        }
                        value={""}
                        onChange={(event) =>
                            // updateField(props.rowIndex, event)
                            //  setValue(event.target.value)
                            console.log()
                        }
                        autoComplete="new-password"
                    />
                    </Col>
                    <Col md={4}></Col>
                </Row>
                <Table style={{ overflowY: "auto" }}>
                    <thead>
                        <tr style={{ border: "1px solid lightgray" }}>
                            {
                                all_columns.map((key, _) =>
                                    <th style={{ border: "1px solid lightgray", padding: 5, verticalAlign: "middle" }}>{key}</th>
                                )
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            props.data.map((row, index) => (
                                <tr
                                    style={headers.includes(Object.keys(row)[0]) ? { cursor: "not-allowed !important", backgroundColor: "lightgray" } : {}}>
                                    {
                                        all_columns.map((column, _) =>
                                            column === "Other Passive"
                                                ?
                                                <td className="custom-summary-table-cell" style={{ minWidth: 250 }}>
                                                    {
                                                        Object.keys(row)[0]
                                                    }
                                                </td>
                                                :
                                                <td
                                                    className="custom-summary-table-cell"
                                                    style={
                                                        headers.includes(Object.keys(row)[0])
                                                            ?
                                                            { fontWeight: 900, textAlign: "center", border: "0px solid black" }
                                                            :
                                                            Object.values(row)[0][column]["disabled"]
                                                                ?
                                                                { cursor: "not-allowed", backgroundColor: "lightgray", border: "1px solid lightgray" }
                                                                : { border: "1px solid lightgray" }
                                                    }
                                                >
                                                    {/* {
                                                        !Object.values(row)[0][column]["disabled"] ?
                                                            <input type="text"
                                                                className={
                                                                    "summary-grid-kone-text-field"
                                                                }
                                                                value={Object.values(row)[0]["K-1 Input"]["value"]}
                                                                onChange={(event) =>
                                                                    // updateField(props.rowIndex, event)
                                                                    //  setValue(event.target.value)
                                                                    console.log()
                                                                }
                                                                autoComplete="new-password"
                                                            />
                                                            :
                                                            <></>
                                                    } */}
                                                    {Object.values(row)[0]["K-1 Input"]["value"]}
                                                </td>

                                        )}
                                </tr>
                            ))}
                    </tbody>
                </Table>
            </>
        )
    }


    return (
        <>
            <Modal
                {...props}
                onHide={() => {
                    // This will close the modal
                    onHide();
                    // This will reset the state when the modal is closed
                    resetState();
                }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                backdropClassName="custom-backdrop"
                centered
                className="full-modal"
                scrollable="false"
            >
                <Modal.Header className="mapping-modal-header" style={{ paddingTop: "0px " }} closeButton>
                    <Navbar collapseOnSelect expand="lg" className="sticky-nav kone-nav">
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="me-auto"></Nav>
                            <Row className="no-gutter flex-row-space-center" style={{ width: "100%" }}>
                                <Col md={6} className="flex-row-center-start pagey">
                                    <Icon.ChevronDoubleLeft
                                        className="k1-page-navigation-btns"
                                        style={{ margin: "0px 10px 0px 0px" }}
                                        onClick={() => setActivePage(1)} />
                                    <Icon.ChevronLeft
                                        className="k1-page-navigation-btns"
                                        style={{ margin: "0px 15px 0px 0px" }}
                                        onClick={() => {
                                            if (activePage > 1) {
                                                setActivePage(activePage - 1)
                                            }
                                        }} />
                                    <div className="no-gutter flex-row-space-center">
                                        Page
                                        <input type="number"
                                            className="form-control move-left custom-input" placeholder={activePage}
                                            value={activePage}
                                            onKeyDown={event => handleKeyDown(event)}
                                            autoComplete="new-password"
                                            style={{ width: 25, padding: "0px 5px", margin: "0px 5px", MozAppearance: "textfield" }}
                                        />
                                        of {totalSummaryPages}
                                    </div>
                                    <Icon.ChevronRight
                                        className="k1-page-navigation-btns"
                                        style={{ margin: "0px 0px 0px 15px" }}
                                        onClick={() => {
                                            if (activePage + 1 <= totalSummaryPages) {
                                                setActivePage(activePage + 1)
                                            }
                                        }} />
                                    <Icon.ChevronDoubleRight className="k1-page-navigation-btns" style={{ margin: "0px 0px 0px 10px" }} onClick={() => setActivePage(totalSummaryPages)} />
                                </Col>
                                <Col md={2} className="flex-row-center-start pagey">
                                    <Button className="custom-button" style={{
                                        width: "fit-content",
                                        display: "inline-block",
                                        padding: "5px 10px",
                                        margin: "0px 20px"
                                    }} onClick={() => setIsOpen(true)} >
                                        Compare
                                    </Button>
                                </Col>
                                <Col md={4} className="flex-row-center-end pagey">
                                    <b>{activeKone["FileName"]["placeholder"]}</b>
                                </Col>
                            </Row>
                        </Navbar.Collapse>
                    </Navbar>
                </Modal.Header>
                <Modal.Body className="admin-modal" style={{ paddingTop: "0px" }}>
                    <Row className='no-gutter'>
                        <div className="flex-row-start-center">
                            {
                                isOpen && (
                                    <Rnd
                                        default={{
                                            x: 0,
                                            y: 0,
                                            width: "590",
                                            height: "750",
                                        }}
                                        minWidth={200}
                                        minHeight={150}
                                        bounds="window"
                                        className="draggable-popup"
                                    >
                                        <div className="draggable-popup-header">
                                            <button onClick={() => handleClose()}
                                                style={{
                                                    fontSize: 30,
                                                    backgroundColor: "transparent",
                                                    cursor: "pointer",
                                                    padding: 0,
                                                    margin: 0,
                                                    position: "fixed",
                                                    right: 0,
                                                    top: -10,
                                                    zIndex: 10003
                                                }}>&times;
                                            </button>
                                        </div>
                                        <div className="draggable-popup-content">
                                            {/* <h6 style={{ margin: "0.5rem 0rem -4rem 0rem", position: "absolute", zIndex: 10001 }}>Original copy</h6> */}
                                            {
                                                (activeK1PdfUrl === "" || activeK1PdfUrl) &&
                                                <div
                                                    className="pdf-wrapper"
                                                    style={{
                                                        overflow: "auto",
                                                        width: 550,
                                                        height: 709
                                                    }}
                                                >
                                                    <Viewer
                                                        fileUrl={activeK1PdfUrl}
                                                        plugins={[rotatePluginInstance, defaultLayoutPluginInstance]}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </Rnd>
                                )}
                        </div>
                        <Row className="no-gutter">
                            {
                                rowData.map((pagedata, _) =>
                                    Object.keys(pagedata)[0] === `Page ${activePage}` &&
                                    <SummaryPageTableRenderer
                                        activepage={activePage}
                                        page={Object.keys(pagedata)[0]}
                                        data={Object.values(pagedata)[0]}
                                    />
                                )
                            }
                        </Row>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}